import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Center,
  Flex,
  Heading,
  Spinner,
  useToast,
  VStack,
  Box
} from '@chakra-ui/react'
import { Form } from './Form'
import usePurchaseRewardPromotions from './hooks/usePurchaseRewardPromotions'
import { PurchaseRewardPromotion } from '@olagg/db-types'
import { PurchaseRewardPromotionFormData } from './Form'
import { ROUTES } from '../../consts/routes'

const EditPurchaseRewardPromotion = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const toast = useToast()
  const { getPromotion, updatePromotion, loading } = usePurchaseRewardPromotions()

  const [promotion, setPromotion] = useState<PurchaseRewardPromotion | null>(null)
  const [loadingPromotion, setLoadingPromotion] = useState(true)

  useEffect(() => {
    const loadPromotion = async () => {
      if (!id) return
      try {
        setLoadingPromotion(true)
        const promotionData = await getPromotion(id)
        setPromotion(promotionData.purchaseRewardPromotion)
      } catch (error) {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la promoción',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
        navigate(ROUTES.PURCHASE_REWARD_PROMOTIONS.all)
      } finally {
        setLoadingPromotion(false)
      }
    }

    loadPromotion()
  }, [id])

  const onSubmit = async (data: PurchaseRewardPromotionFormData) => {
    if (!promotion) return

    try {
      await updatePromotion(promotion.uid, data)
      toast({
        title: 'Promoción actualizada',
        description: 'La promoción ha sido actualizada exitosamente',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      navigate(ROUTES.PURCHASE_REWARD_PROMOTIONS.all)
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo actualizar la promoción',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  const onCancel = () => {
    navigate(ROUTES.PURCHASE_REWARD_PROMOTIONS.all)
  }

  if (loadingPromotion) {
    return (
      <Flex justify="center" align="center" h="200px">
        <Spinner size="lg" />
      </Flex>
    )
  }

  if (!promotion) {
    return (
      <Box>
        <Heading size="md" color="red.500">
          Promoción no encontrada
        </Heading>
      </Box>
    )
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Editar Promoción de Recompensa</Heading>

        <Form
          initialData={promotion}
          onSubmit={onSubmit}
          onCancel={onCancel}
          loading={loading}
          isEdit={true}
        />
      </VStack>
    </Center>
  )
}

export default EditPurchaseRewardPromotion;
